





























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { RoutePaths } from '@/router'
import { AuthStateData } from '@/services/UserManager'
import { Subscription } from 'rxjs'
import appManager from '@/services/AppManager'
import { UserRole } from '@/core/Types'

@Component
export default class PortalHomeView extends Vue {
    // user state
    authState: AuthStateData|null = null
    authStateCounter: number = 0 // simple way to force a refresh when the state changes
    authStateSubscription: Subscription|undefined

    // noinspection JSUnusedGlobalSymbols
    created() {
        this.authStateSubscription = appManager.userManager.stateStream.subscribe(state => this.onAuthStateChanged(state))
    }

    // noinspection JSUnusedGlobalSymbols
    destroyed() {
        if (this.authStateSubscription)
            this.authStateSubscription.unsubscribe()
    }

    getButtonHeight(): string {
        return this.$vuetify.breakpoint.smAndUp ? '140px' : '100px'
    }

    isUserAdmin(): boolean {
        return this.authState?.user?.data?.role === UserRole.ADMIN
    }

    isUserCompanyOwner(): boolean {
        return this.authState?.user?.data?.role === UserRole.COMPANY_OWNER
    }

    get subscriptionsPath(): string {
        return RoutePaths.SUBSCRIPTIONS
    }

    get usersPath(): string {
        return RoutePaths.USERS
    }

    get accessCodesPath(): string {
        return RoutePaths.ACCESS_CODES
    }

    get equipmentPath(): string {
        return RoutePaths.EQUIPMENT
    }

    get apiEventsPath(): string {
        return RoutePaths.API_EVENTS
    }

    get apiKeysPath(): string {
        return RoutePaths.API_KEYS
    }

    get couponsPath(): string {
        return RoutePaths.COUPONS
    }

    get invoicesPath(): string {
        return RoutePaths.INVOICES
    }

    get paymentMethodsPath(): string {
        return RoutePaths.PAYMENT_METHODS
    }

    get companyProfilePath(): string {
        return RoutePaths.COMPANY_PROFILE
    }

    get myProfilePath(): string {
        return RoutePaths.MY_PROFILE
    }

    get userManualPath(): string {
        return RoutePaths.DOCS_USER_MANUAL
    }

    private onAuthStateChanged(state: AuthStateData) {
        this.authState = state
        this.authStateCounter += 1
    }
}
